import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsService, Unit } from 'src/app/services/account/settings.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Turn } from 'src/app/models/route';
import { TurnValueIntegerPipe } from 'src/app/pipes/turn-value-integer.pipe';
import { TurnValueIntegerThousandsPipe } from 'src/app/pipes/turn-value-integer-thousands.pipe';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';
import { SvgGradientStop } from 'src/app/services/media/svg-recolor.service';

@Component({
  standalone: true,
  selector: 'app-turn',
  templateUrl: './turn.component.html',
  styleUrls: ['./turn.component.scss'],
  imports: [CommonModule, TurnValueIntegerPipe, TurnValueIntegerThousandsPipe, SvgRecolorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TurnComponent {
  @Input() turn!: Turn;
  @Input() turnDistance!: number;

  public readonly baseGradientStops: SvgGradientStop[] = [
    { offset: 0, color: '--base-gradient-color-1' },
    { offset: 1, color: '--base-gradient-color-2' }
  ];

  constructor(public settingsService: SettingsService, private utilsService: UtilsService) { }

  public showMetricMeter(m: number): boolean {
    return m < 1000 && this.settingsService.getUnit().Distance == Unit.Metric;
  }

  public showMetricKMeter(m: number): boolean {
    return m >= 1000 && this.settingsService.getUnit().Distance == Unit.Metric;
  }

  public showImperialYard(m: number): boolean {
    return this.utilsService.mToYard(m) < 1760 && this.settingsService.getUnit().Distance == Unit.Imperial;
  }

  public showImperialMile(m: number): boolean {
    return this.utilsService.mToYard(m) >= 1760 && this.settingsService.getUnit().Distance == Unit.Imperial;
  }
}
